import styled from "styled-components";
import { Link } from "react-router-dom";
import type { Theme } from "../../../constants/themeConstants";

export const FooterNavContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 48px;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

export const NavColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 170px;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const NavLink = styled(Link)`
  color: ${({ theme }) => (theme as Theme).colors.textColor};
  text-decoration: none;
  min-width: 74px;
  height: 42;
  gap: 8px;
  padding: 12px 8px;

  font-weight: 700;
  font-size: 16px;
  line-height: 110%;
  letter-spacing: 0%;

  &:hover {
    text-decoration: none;
    color: ${({ theme }) => (theme as Theme).colors.hoverTextColor};
  }
`;

export const DropdownGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;

  max-width: 728px;
  width: 100%;
  gap: 4px;

  @media (max-width: 768px) {
    max-width: 100%;
    grid-auto-flow: row;
    margin-top: 12px;
    gap: 16px;
  }
`;

export const DropdownItem = styled(Link)`
  color: ${({ theme }) => (theme as Theme).colors.textColor};
  text-decoration: none;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;

  padding: 0 12px 0 8px;

  display: flex;
  align-items: center;

  max-width: 150px;
  width: 100%;

  @media (max-width: 768px) {
    max-width: unset;
  }

  &:hover {
    text-decoration: none;
    color: ${({ theme }) => (theme as Theme).colors.hoverTextColor};
  }
`;
